import { MutationTree } from 'vuex';
import { AdminState } from './types';
import { SET_WHITELIST } from './mutationTypes';
import { WhitelistEntry } from '@/types';

export const mutations: MutationTree<AdminState> = {
  [SET_WHITELIST](state, entries: WhitelistEntry[]) {
    state.whitelist = entries;
    state.isWhitelistLoaded = true;
  },
};
